import { render, staticRenderFns } from "./Publication.vue?vue&type=template&id=6aa964c1&scoped=true"
import script from "./Publication.vue?vue&type=script&setup=true&lang=js"
export * from "./Publication.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Publication.vue?vue&type=style&index=0&id=6aa964c1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa964c1",
  null
  
)

export default component.exports